module.exports = __webpack_public_path__ + "static/media/girl-15.9088818f.svg";